import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppSettingService {
    appTheme$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    isSNAStateLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    clientIds: any;
    geoLocations: any;

    setGeoLocationAndClientIds(data: any, type: 'geoLocation' | 'clientIds') {
        if (type === 'geoLocation') {
            this.geoLocations = data;
        } else {
            this.clientIds = data;
        }
    }
}
